import type { Locale } from '@/i18n'

interface NavLink {
  label: string
  href: string
}

interface NavCopy {
  links: readonly NavLink[]
  /** Arrow-less; the trailing " →" is appended on desktop only. */
  ctaLabel: string
  menuLabel: string
}

const HREFS = ['#services', '#ai', '#process', '#work', '#studio', '#contact'] as const

const withHrefs = (labels: readonly string[]): readonly NavLink[] =>
  labels.map((label, index) => ({ label, href: HREFS[index] ?? '#top' }))

export const NAV_COPY: Record<Locale, NavCopy> = {
  en: {
    links: withHrefs(['Services', 'AI', 'Process', 'Work', 'Studio', 'Contact']),
    ctaLabel: 'Book a call',
    menuLabel: 'Menu',
  },
  hu: {
    links: withHrefs(['Szolgáltatások', 'AI', 'Módszer', 'Referenciák', 'Stúdió', 'Kapcsolat']),
    ctaLabel: 'Egyeztessünk',
    menuLabel: 'Menü',
  },
}
